import { push } from 'connected-react-router';

export function redirect(url) {
  return (dispatch) => {
    dispatch(push(url));
  };
}
